<template>
  <div>
    <transition name="modal">
      <meal-set-modal
        v-if="showMealSetDetail"
        :mealSet="mealSet"
        :addPrint="addPrint"
        @close="showMealSetDetail = false"
        @printMeal="$emit('printMeal', $event)"
      ></meal-set-modal>
    </transition>

    <div class="card-bordered w-full">
      <div class="flex justify-between items-center">
        <p class="font-medium">Semana #{{ index }}</p>

        <div class="flex items-center">
          <div class="flex space-x-2">
            <button
              class="secondary-button"
              @click.prevent="showMealSetDetail = true"
            >
              Detalle
            </button>

            <edit-button v-if="editEnabled" @click.prevent="$emit('edit')" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MealSetModal from "../modals/MealSetModal";
export default {
  name: "Meal Set",

  components: {
    MealSetModal,
  },

  data() {
    return {
      showMealSetDetail: false,
    };
  },

  props: {
    index: Number,
    mealSet: Object,
    editEnabled: false,
    addPrint: Boolean,
  },

  methods: {
    integerToCurrency(amount) {
      if (amount == null) {
        return "-";
      }

      const formatter = new Intl.NumberFormat("es-MX", {
        style: "currency",
        currency: "MXN",
        minimumFractionDigits: 2,
      });

      return formatter.format(amount);
    },
  },
};
</script>